<template>
  <v-dialog v-model="dialog" persistent width="500">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon
          >Ampliación de la programación de vacaciones
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md12>
                <v-text-field
                  label="Fecha ampliación de programación"
                  v-model="form.fecha_ampliacion"
                  type="date"
                  :rules="$validate(['required'])"
                  required
                  maxlength="200"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn color="primary" type="submit" :loading="loading">
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false
    };
  },
  mounted() {
    this.$bus.$on("openDialogAmpliacion", item => {
      this.form = item;
      this.dialog = true;
    });
  },
  methods: {
    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.$bus.$emit("closeDialog");
      this.dialog = false;
	  this.form={}
    },
    async save() {
      if (this.$refs.form.validate()) {
		let user = this.$storage.get("user");
        this.$confirm(
          `Esta seguro de ampliar la programación de vacaciones hasta el <strong>${this.$moment(
            this.form.fecha_ampliacion
          ).format("DD-MM-YYYY")}</strong>?`,
          async () => {
            try {
              const id = this.form.id;
              let respuesta = await this.$service.graphql({
                query: `
				query{
                	runQuery(consulta:"select vacaciones.fn_registra_fecha_ampliacion(${id},'${this.form.fecha_ampliacion}',${user.id})"){
                    	respuesta
                      }
                    }
				`,
                variables: {
                  programacion: this.form
                }
              });
              respuesta =
                respuesta.runQuery.respuesta[0].fn_registra_fecha_ampliacion;
              let resps = respuesta.split("|");
              let correcto = resps[0];
              if (correcto == "1") {
                this.$alert(resps[1]);
                this.close();
              } else {
                this.$alert(resps[1]);
              }
            } catch (error) {
              console.log(error);
            }
          }
        );
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/parametros_vacacion/dialogs/Ampliacion.vue